import { useState, FormEvent } from 'react';

export default function ContactInfo() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const hpField = formData.get('company_alt');
    if (hpField && String(hpField).trim() !== '') {
      setFormStatus('success');
      setFormMessage('感谢您的咨询，我们会尽快与您联系！');
      return;
    }

    setFormStatus('submitting');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9qqvjsnlsngrm4lm4c0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
          Array.from(formData.entries())
            .filter(([key]) => key !== 'company_alt')
            .map(([key, value]) => [key, String(value)])
        ).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormMessage('感谢您的咨询，我们会尽快与您联系！');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        setFormStatus('error');
        setFormMessage(typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后重试');
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络错误，请稍后重试');
    }
  };

  return (
    <section id="contact" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-4">
            联系我们
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            开启品牌增长之旅
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            留下您的需求，我们的商务团队会在24小时内与您联系
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 max-w-5xl mx-auto">
          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-line text-primary-600"></i>
              </div>
              <div>
                <h4 className="font-medium text-foreground-900 mb-1">公司地址</h4>
                <p className="text-sm text-foreground-500">北京市朝阳区建国路88号SOHO现代城A座 18层</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-phone-line text-primary-600"></i>
              </div>
              <div>
                <h4 className="font-medium text-foreground-900 mb-1">联系电话</h4>
                <p className="text-sm text-foreground-500">010-8888-6666</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-primary-600"></i>
              </div>
              <div>
                <h4 className="font-medium text-foreground-900 mb-1">商务合作</h4>
                <p className="text-sm text-foreground-500">hello@guodongmedia.com</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-time-line text-primary-600"></i>
              </div>
              <div>
                <h4 className="font-medium text-foreground-900 mb-1">工作时间</h4>
                <p className="text-sm text-foreground-500">周一至周五 9:00 - 18:00</p>
              </div>
            </div>
          </div>

          <div>
            <form onSubmit={handleSubmit} data-readdy-form="" className="bg-background-100 rounded-lg p-6 border border-background-200/70 space-y-4">
              <div>
                <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">您的姓名</label>
                <input
                  id="contact-name"
                  name="name"
                  type="text"
                  required
                  className="w-full px-4 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors"
                  placeholder="请输入您的姓名"
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">电子邮箱</label>
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  required
                  className="w-full px-4 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors"
                  placeholder="请输入您的邮箱"
                />
              </div>
              <div>
                <label htmlFor="contact-phone" className="block text-sm font-medium text-foreground-700 mb-1.5">联系电话</label>
                <input
                  id="contact-phone"
                  name="phone"
                  type="tel"
                  className="w-full px-4 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors"
                  placeholder="请输入您的电话（选填）"
                />
              </div>
              <div>
                <label htmlFor="contact-company" className="block text-sm font-medium text-foreground-700 mb-1.5">公司名称</label>
                <input
                  id="contact-company"
                  name="company"
                  type="text"
                  className="w-full px-4 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors"
                  placeholder="请输入您的公司名称（选填）"
                />
              </div>
              <div>
                <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">需求描述</label>
                <textarea
                  id="contact-message"
                  name="message"
                  required
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-colors resize-none"
                  placeholder="请简要描述您的需求（限500字）"
                ></textarea>
              </div>
              <div className="hp-field-wrap">
                <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <button
                type="submit"
                disabled={formStatus === 'submitting'}
                className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
              >
                {formStatus === 'submitting' ? '提交中...' : '提交需求'}
              </button>

              {formStatus === 'success' && (
                <p className="text-sm text-accent-600 text-center">{formMessage}</p>
              )}
              {formStatus === 'error' && (
                <p className="text-sm text-red-500 text-center">{formMessage}</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}